module.exports = __webpack_public_path__ + "img/Logo_Animation.0167ec76.gif";